const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');

const AddReminder = forgeUiComponent('AddReminder', {
  subscribing: 'is-subscribing'
}, function PodcastInfoConstructor() {
  const self = this;
  const subscribeButton = this.element.querySelector('.AddReminder-subscribeButton') || document.createElement('div');

  this.element.addEventListener(events.uiModalDismiss, function () {
    self.subscribing = false;
  });

  subscribeButton.addEventListener('click', function openSubscribeDialog(e) {
    e.preventDefault();
    self.subscribing = true;
  });
});

module.exports = AddReminder;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/add-reminder.js
// module id = 53
// module chunks = 0